import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import EthosReaderForm from '../forms/ethos-reader-form';
import { ethosReaderValidationSchema } from '../schema/ethosReader.js';

export default function EthosReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Ethos Reader Node Details',
        altText: 'Ethos Reader Node',
        defaultLabel: 'Ethos Reader Node',
      }}
    >
      <CommonNode FormComponent={EthosReaderForm} schemaResolver={ethosReaderValidationSchema} />
    </NodeProvider>
  );
}
